import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { DocumentState } from './document.state';
import * as DocumentActions from './document.action';

export const initialDocumentState: DocumentState = {
  entityDocument: { entityId: 0 },
  loading: false,
  loaded: false,
  error: null,

  documentViewerConfiguration: null,
  documentViewerConfigurationLoaded: false,
  documentViewerConfigurationLoading: false
};

const getEntityDocumentFeatureState = createFeatureSelector<DocumentState>('entityDocument');

export const getEntityDocument = createSelector(
  getEntityDocumentFeatureState,
  state => state.entityDocument
);

export const getEntityDocumentLoaded = createSelector(
  getEntityDocumentFeatureState,
  state => state.loaded
);

export const getEntityDocumentError = createSelector(
  getEntityDocumentFeatureState,
  state => state.error
);

export const getDocumentViewerConfiguration = createSelector(
  getEntityDocumentFeatureState,
  state => state.documentViewerConfiguration
);

export const getDocumentViewerConfigurationLoaded = createSelector(
  getEntityDocumentFeatureState,
  state => state.documentViewerConfigurationLoaded
);

export function documentReducer(state = initialDocumentState, action: DocumentActions.EntityDocumentActions): DocumentState {
  switch (action.type) {
    case DocumentActions.EntityDocumentActionTypes.LoadEntityDocument:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };

    case DocumentActions.EntityDocumentActionTypes.LoadEntityDocumentSuccess:
      return {
        ...state,
        entityDocument: action.documents,
        loading: false,
        loaded: true
      };

    case DocumentActions.EntityDocumentActionTypes.LoadEntityDocumentFail:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload
      };

    case DocumentActions.EntityDocumentActionTypes.LoadDocumentViewerConfiguration:
      return {
        ...state,
        documentViewerConfigurationLoading: true
      };

    case DocumentActions.EntityDocumentActionTypes.LoadDocumentViewerConfigurationSuccess:
      return {
        ...state,
        documentViewerConfiguration: action.config,
        documentViewerConfigurationLoaded: true,
        documentViewerConfigurationLoading: false
      };
      
    case DocumentActions.EntityDocumentActionTypes.LoadDocumentViewerConfigurationFail:
      return {
        ...state,
        documentViewerConfigurationLoaded: false,
        documentViewerConfigurationLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
}